import React from 'react';

// Chargement à la demande des pages (code splitting).
//
// Avant : App.js importait les 204 pages en dur → un seul bundle de 7,8 Mo
// téléchargé à chaque ouverture du portail, quelle que soit la page visitée.
// Après : chaque page est un chunk chargé au premier passage sur sa route.
//
// Piège couvert ici : un déploiement remplace les chunks (noms hachés). Un
// onglet ouvert AVANT le déploiement garde l'ancien index.html et demande un
// chunk qui n'existe plus → « ChunkLoadError ». On recharge alors la page UNE
// fois (sessionStorage comme témoin) pour récupérer le nouvel index ; si le
// chunk manque encore après rechargement, l'erreur remonte normalement au
// SmartErrorBoundary — on ne boucle jamais.
const RELOAD_KEY = 'meteris_chunk_reload';

function readFlag() {
  try { return window.sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (e) { return false; }
}

function writeFlag(value) {
  try {
    if (value) window.sessionStorage.setItem(RELOAD_KEY, '1');
    else window.sessionStorage.removeItem(RELOAD_KEY);
  } catch (e) { /* stockage indisponible : on retombe sur l'erreur normale */ }
}

export function lazyPage(importer) {
  return React.lazy(() => importer().then(
    (mod) => { writeFlag(false); return mod; },
    (err) => {
      if (typeof window !== 'undefined' && !readFlag()) {
        writeFlag(true);
        window.location.reload();
        // Promesse jamais résolue : la page est en train de se recharger.
        return new Promise(() => {});
      }
      throw err;
    },
  ));
}

// Fallback affiché pendant le chargement d'un chunk. Il vit DANS le layout
// (sidebar et fil d'Ariane restent en place) — cf. la règle « pas d'écran de
// chargement plein page » du CLAUDE.md.
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)', fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 13 }}
    >
      Chargement…
    </div>
  );
}
